<template>
    <Button label="Добавить подписку" icon="pi pi-plus" class="flex" @click="showDialog" severity="info" size="small"/>

    <Dialog
        class="flex flex-column border-none max-w-30rem p-0 m-0 xl:m-3 lg:m-2 md:m-1"
        modal
        v-model:visible="dialog"
        style="max-height:100%!important"
        :position="screenSize == 'xs' ? 'bottom' : 'right'"
        :style="dialogStyle"
        :contentStyle="contentStyle"
        :class="screenSize == 'xs' ? 'h-full border-noround-bottom' : ''"
    >
        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Добавить подписку</span>
            </div>
        </template>

        <div class="flex flex-column w-full h-full gap-3 overflow-auto">
            <div class="grid">
                <!-- <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Проект <span class="text-red-500">*</span>:</span>
                    <Select v-model="form.project_id" :options="projects" optionLabel="label" optionValue="value" placeholder="Выберите проект" class="w-full" :loading="loading"/>
                </div> -->

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Обменник <span class="text-red-500">*</span>:</span>
                    <Select v-model="form.user_id" :options="users" filter optionLabel="name" optionValue="id" placeholder="Выберите обменник" class="w-full" :loading="loading"/>
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Клиент <span class="text-red-500">*</span>:</span>
                    <InputText v-model="form.client_id" class="w-full" placeholder="ID клиента" :disabled="loading" />
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Банк <span class="text-red-500">*</span>:</span>
                    <Select v-model="form.payment_system_code" :options="banks_" optionLabel="label" optionValue="value" placeholder="Выберите банк" class="w-full" :loading="loading"/>
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Сумма <span class="text-red-500">*</span>:</span>
                    <InputNumber v-model="form.amount" class="w-full" :minFractionDigits="0" :maxFractionDigits="2" :min="48" :max="3500" placeholder="100" :currency="form.currency" mode="currency" :disabled="loading"/>
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Валюта <span class="text-red-500">*</span>:</span>
                    <Select v-model="form.currency" :options="currencies" placeholder="Выберите валюту" class="w-full" :loading="loading"/>
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Единица периода <span class="text-red-500">*</span>:</span>
                    <Select v-model="form.period_unit" :options="periodUnits" placeholder="Выберите период" class="w-full" :loading="loading"/>
                </div>

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Количество периодов <span class="text-red-500">*</span>:</span>
                    <InputNumber v-model="form.period_count" class="w-full" :useGrouping="false" :min="1" placeholder="1" :disabled="loading" />
                </div>

                <!-- <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Статус:</span>
                    <Select v-model="form.status" :options="statuses" placeholder="Выберите статус" class="w-full" :loading="loading"/>
                </div> -->

                <!-- <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Внешний ID:</span>
                    <InputText v-model="form.ext_subscription_id" class="w-full" placeholder="ext_subscription_id" :disabled="loading" />
                </div> -->

                <!-- <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Токен:</span>
                    <InputText v-model="form.subscription_token" class="w-full" placeholder="subscription_token" :disabled="loading" />
                </div> -->

                <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Первая дата списания:</span>
                    <DatePicker v-model="form.first_charge_at" showTime hourFormat="24" fluid />
                </div>

                <!-- <div class="col-12 md:col-6 flex flex-column gap-2">
                    <span class="flex">Следующая дата списания:</span>
                    <DatePicker v-model="form.next_charge_at" showTime hourFormat="24" fluid />
                </div> -->

                <!-- <div class="col-12 flex flex-column gap-2">
                    <span class="flex">Approval URL:</span>
                    <InputText v-model="form.approval_url" class="w-full" placeholder="https://..." :disabled="loading" />
                </div> -->

                <div class="col-12 flex flex-column gap-2">
                    <span class="flex">Описание:</span>
                    <Textarea v-model="form.description" rows="3" autoResize :disabled="loading" />
                </div>

                <!-- <div class="col-12 flex flex-column gap-2">
                    <span class="flex">Сообщение:</span>
                    <Textarea v-model="form.message" rows="2" autoResize :disabled="loading" />
                </div> -->

                <!-- <div class="col-12 flex flex-column gap-2">
                    <span class="flex">Metadata JSON:</span>
                    <Textarea v-model="metadataText" rows="4" autoResize :disabled="loading" placeholder='{"source":"admin"}' />
                </div> -->
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap gap-2">
                <Button label="Добавить" @click="addSubscription" :loading="loading" class="flex" :disabled="loading || !canSubmit" severity="info"/>
                <Button label="Закрыть" icon="pi pi-times" @click="dialog = false" outlined class="flex" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'

const createInitialForm = () => ({
    project_id: null,
    user_id: null,
    client_id: '',
    payment_system_code: null,
    // ext_subscription_id: '',
    // subscription_token: '',
    amount: null,
    currency: 'rub',
    period_unit: 'month',
    period_count: 1,
    // status: 'pending',
    // message: '',
    description: '',
    // approval_url: '',
    first_charge_at: null,
    // next_charge_at: null
})

export default {
    props: {
        users: {
            type: Array,
            default: () => []
        },
        projects: {
            type: Array,
            default: () => []
        },
        banks: {
            type: Array,
            default: () => []
        },
        statuses: {
            type: Array,
            default: () => []
        }
    },
    emits: ['added'],
    data() {
        return {
            loading: false,
            dialog: false,
            form: createInitialForm(),
            metadataText: '',
            banks_: [
                {
                    value: 'aquaman',
                    label: 'Dolinsk Bank'
                },
            ],
        }
    },
    computed: {
        screenSize() {
            return this.$store.getters.StateScreenSize
        },
        dialogStyle() {
            return this.screenSize == 'xs' || this.screenSize == 'sm' || this.screenSize == 'md'
                ? { width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important' }
                : { width: '900px', height: '100%!important' }
        },
        contentStyle() {
            return this.screenSize == 'xs' || this.screenSize == 'sm' || this.screenSize == 'md'
                ? { height: '100%' }
                : { height: 'auto' }
        },
        currencies() {
            return ['RUB']
        },
        periodUnits() {
            return ['min5', 'hour1', 'day', 'week', 'month', 'month3', 'month6', 'year']
        },
        canSubmit() {
            return Boolean(
                // this.form.project_id &&
                this.form.user_id &&
                this.form.client_id &&
                this.form.payment_system_code &&
                this.form.amount !== null &&
                this.form.amount !== undefined &&
                this.form.currency &&
                this.form.period_unit &&
                this.form.period_count
            )
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity, summary, detail, life: 3000 })
        },
        showDialog() {
            this.dialog = true
        },
        resetForm() {
            this.form = createInitialForm()
            this.metadataText = ''
        },
        formatDateForApi(value) {
            if (!value) return null
            const date = value instanceof Date ? value : new Date(value)
            if (Number.isNaN(date.getTime())) return null
            return date.toISOString()
        },
        buildPayload() {
            let metadata = undefined
            if (this.metadataText && this.metadataText.trim()) {
                metadata = JSON.parse(this.metadataText)
            }

            return {
                // project_id: this.form.project_id,
                user_id: this.form.user_id,
                client_id: this.form.client_id,
                payment_system_code: this.form.payment_system_code,
                // ext_subscription_id: this.form.ext_subscription_id || undefined,
                // subscription_token: this.form.subscription_token || undefined,
                amount: Number(this.form.amount),
                currency: this.form.currency,
                period_unit: this.form.period_unit,
                period_count: Number(this.form.period_count),
                // status: this.form.status || undefined,
                // message: this.form.message || undefined,
                description: this.form.description || undefined,
                // approval_url: this.form.approval_url || undefined,
                first_charge_at: this.formatDateForApi(this.form.first_charge_at),
                // next_charge_at: this.formatDateForApi(this.form.next_charge_at),
                // metadata
            }
        },
        async addSubscription() {
            if (!this.canSubmit) {
                this.showMess('error', 'Ошибка', 'Заполните обязательные поля')
                return
            }

            let payload
            try {
                payload = this.buildPayload()
            } catch (error) {
                this.showMess('error', 'Ошибка', 'Metadata должно быть валидным JSON')
                return
            }

            this.loading = true
            try {
                const response = await this.connect.AddAdminSubscription(payload).then(res => res)
                if (response && response.result) {
                    this.showMess('success', 'Успешно', 'Подписка добавлена')
                    this.dialog = false
                    this.resetForm()
                    this.$emit('added', response.data)
                } else {
                    this.showMess('error', 'Ошибка', response && response.message ? response.message : 'Ошибка при добавлении подписки')
                }
            } catch (error) {
                this.showMess('error', 'Ошибка', 'Ошибка при добавлении подписки')
            } finally {
                this.loading = false
            }
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
    }
}
</script>